(function () {
  'use strict';

  var root = document.querySelector('[data-milanus-home-products]');
  if (!root) return;

  var grid = root.querySelector('[data-milanus-home-product-grid]');
  var pagination = root.querySelector('[data-milanus-home-pagination]');
  if (!grid || !pagination || !window.IntersectionObserver || !window.fetch || !window.DOMParser) return;

  var fallback = pagination.querySelector('[data-milanus-home-pagination-fallback]');
  var status = pagination.querySelector('[data-milanus-home-pagination-status]');
  var sentinel = pagination.querySelector('[data-milanus-home-pagination-sentinel]');
  var nextUrl = pagination.getAttribute('data-next-url');
  var currentPage = parseInt(pagination.getAttribute('data-current-page'), 10) || 1;
  var requestedUrls = {};
  var loading = false;
  var observer;

  pagination.classList.add('is-enhanced');

  function absoluteUrl(url) {
    return new URL(url, window.location.href).href;
  }

  function setStatus(message) {
    status.textContent = message || '';
  }

  function setNextUrl(url) {
    nextUrl = url || '';
    if (nextUrl) {
      fallback.setAttribute('href', nextUrl);
      pagination.setAttribute('data-next-url', nextUrl);
      return;
    }

    pagination.removeAttribute('data-next-url');
    pagination.classList.add('is-complete');
    setStatus(pagination.getAttribute('data-complete-text'));
    if (observer) observer.disconnect();
  }

  function reinitializeCards() {
    if (window.roar) {
      try {
        if (typeof window.roar.loadingEffects === 'function') window.roar.loadingEffects();
        if (typeof window.roar.handleReviews === 'function') window.roar.handleReviews();
      } catch (error) {
        // Appended cards remain fully usable when an optional legacy enhancer fails.
      }
    }
    try {
      if (typeof window.currenciesCallbackSpecial === 'function') window.currenciesCallbackSpecial('span.money');
    } catch (error) {
      // Prices are already server-rendered in the active currency.
    }
    try {
      document.dispatchEvent(new CustomEvent('milanus:home-products-appended', { bubbles: true }));
    } catch (error) {
      // The event is an integration hook, not a loading requirement.
    }
  }

  function loadNextPage(options) {
    options = options || {};
    if (!nextUrl || loading) return Promise.resolve(false);

    var requestUrl = absoluteUrl(nextUrl);
    if (requestedUrls[requestUrl]) return Promise.resolve(false);

    requestedUrls[requestUrl] = true;
    loading = true;
    pagination.classList.remove('has-error');
    pagination.classList.add('is-loading');
    setStatus(pagination.getAttribute('data-loading-text'));

    return fetch(requestUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Homepage pagination request failed: ' + response.status);
      return response.text();
    }).then(function (html) {
      var page = new DOMParser().parseFromString(html, 'text/html');
      var nextGrid = page.querySelector('[data-milanus-home-product-grid]');
      var nextPagination = page.querySelector('[data-milanus-home-pagination]');
      if (!nextGrid) throw new Error('Homepage product grid missing from paginated response');

      var cards = Array.prototype.slice.call(nextGrid.children);
      var fragment = document.createDocumentFragment();
      cards.forEach(function (card) { fragment.appendChild(document.importNode(card, true)); });
      grid.appendChild(fragment);

      currentPage += 1;
      pagination.setAttribute('data-current-page', String(currentPage));
      setNextUrl(nextPagination ? nextPagination.getAttribute('data-next-url') : '');
      if (nextUrl) setStatus(options.restoring ? '' : pagination.getAttribute('data-loaded-text'));
      reinitializeCards();
      return true;
    }).catch(function () {
      delete requestedUrls[requestUrl];
      pagination.classList.add('has-error');
      setStatus(pagination.getAttribute('data-error-text'));
      if (observer) observer.disconnect();
      return false;
    }).finally(function () {
      loading = false;
      pagination.classList.remove('is-loading');
    });
  }

  function saveReturnState(event) {
    var link = event.target.closest('a[href]');
    if (!link || !link.closest('[data-milanus-home-product-grid]')) return;

    var state = Object.assign({}, window.history.state || {});
    state.milanusHomeProducts = {
      page: currentPage,
      scrollY: window.scrollY,
      productUrl: absoluteUrl(link.getAttribute('href'))
    };
    window.history.replaceState(state, document.title, window.location.href);
  }

  function restoreReturnState() {
    var saved = window.history.state && window.history.state.milanusHomeProducts;
    if (!saved || !saved.page || saved.page <= currentPage) {
      if (saved && typeof saved.scrollY === 'number') window.scrollTo(0, saved.scrollY);
      return Promise.resolve();
    }

    function loadUntilReady() {
      if (currentPage >= saved.page || !nextUrl) return Promise.resolve();
      return loadNextPage({ restoring: true }).then(function (loaded) {
        return loaded ? loadUntilReady() : undefined;
      });
    }

    return loadUntilReady().then(function () {
      window.requestAnimationFrame(function () {
        var productLink = Array.prototype.find.call(grid.querySelectorAll('a[href]'), function (link) {
          return absoluteUrl(link.getAttribute('href')) === saved.productUrl;
        });
        if (productLink) productLink.scrollIntoView({ block: 'center' });
        else window.scrollTo(0, saved.scrollY || 0);
      });
    });
  }

  grid.addEventListener('click', saveReturnState);
  observer = new IntersectionObserver(function (entries) {
    if (entries.some(function (entry) { return entry.isIntersecting; })) loadNextPage();
  }, { rootMargin: '900px 0px', threshold: 0 });

  restoreReturnState().then(function () {
    if (nextUrl) observer.observe(sentinel);
  });
}());
